import { UsefulLink } from "@/features/planner/api/planner";

interface UsefulLinksProps {
    links: UsefulLink[];
}

export const UsefulLinks = ({ links }: UsefulLinksProps) => {
    if (!links || links.length === 0) return null;

    return (
        <div className="mb-6 mx-5 bg-white p-10">
            <h2 className="text-center text-[#187A85] text-2xl font-bold mb-6">Useful Links</h2>

            <div className="p-8 rounded-lg">
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {links.map((link, index) => (
                        <li key={index} className="bg-[#FFF9F2] p-4 rounded-lg flex items-start gap-2.5">
                            <span className="text-[#E85D24] text-lg leading-none mt-1">→</span>
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#187A85] text-base font-semibold hover:underline hover:text-[#13616a] transition-colors"
                            >
                                {link.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
